import { createSlice } from "@reduxjs/toolkit";
import { DefaultPaginable } from "const";

const initialState = {
  loadingCategory: false,
  activeCategory: null,
  categories: [],
  research: {},
};

const slice = createSlice({
  initialState,
  name: "research",
  reducers: {
    getResearchCategory: (state) => {
      state.loadingCategory = true;
    },
    getResearchCategorySuccess: (state, action) => {
      state.loadingCategory = false;
      state.categories = action.payload;
      state.activeCategory = String(action.payload[0]?.categoryNo);
    },
    getResearchCategoryFailure: (state) => {
      state.loadingCategory = false;
      state.categories = [];
      state.activeCategory = null;
    },
    changeActiveCategory: (state, action) => {
      state.activeCategory = action.payload;
    },
    fetchResearchInit: () => {},
    requestFetchResearch: (state, { payload: categoryNo }) => {
      const research = state.research[categoryNo];
      if (!research) {
        state.research[categoryNo] = {
          loading: false,
          news: [],
          paginable: { ...DefaultPaginable, current: 0, pageSize: 20 },
        };
      }
    },
    fetchResearch: (state, { payload: categoryNo }) => {
      state.research[categoryNo].loading = true;
    },
    fetchResearchSuccess: (state, { payload }) => {
      const research = state.research[payload.categoryNo];
      research.loading = false;
      research.news = [...research.news, ...(payload.news || [])];
      research.paginable = { ...research.paginable, ...payload.paginable };
      research.total = payload.total;
      research.end = payload.total === 0 || research.news.length === payload.total;
    },
    fetchResearchFailure: (state, { payload }) => {
      state.research[payload.categoryNo].loading = false;
    },
  },
});

export const {
  getResearchCategory,
  getResearchCategorySuccess,
  getResearchCategoryFailure,
  changeActiveCategory,
  requestFetchResearch,
  fetchResearchInit,
  fetchResearch,
  fetchResearchSuccess,
  fetchResearchFailure,
} = slice.actions;

export default slice;
